import { get } from '../utils/api';

/**
 * 挖矿资产服务
 */
export const miningAssetService = {
  // 获取今日挖矿资产
  getTodayAssets: async () => {
    const response = await get('/mining-assets/today');
    return response.data;
  },

  // 获取挖矿资产列表
  getAssetList: async (page = 1, size = 10, keyword = '') => {
    const response = await get('/mining-assets', { page, size, keyword });
    return response.data;
  },
};

